module.exports = __webpack_public_path__ + "static/img/BL.c06cd294.svg";